<template>
    
    <b-row>
        <b-col md="4" cols="12">
            <info-card
            label="رقم محضر الاجتماع"
            :value="data.title"
            />
        </b-col>
        <b-col md="4" cols="12">
            <info-card label=" تاريخ محضر الاجتماع"
            :value="data.meeting_date"
            />
        </b-col>
        <b-col md="4" cols="12">
            <info-card
            label="نوع الإجتماع"
            :value="data.meeting_type_id ? data.meeting_type_id.name_ar : ''"
            />
                
        </b-col>
        <b-col md="4" cols="12">
            <info-card label="أسماء الحضور" 
            :value="data.attendance_names"
            />
        </b-col>
        <b-col cols="4">
            <div class="info-card px-2 py-1 my-1">
            <div class="d-flex align-items-center justify-content-between">
                <div>
                محضر الإجتماع
                </div>
                <div>
                <b-button
                
                    variant="flat-info"
                    v-b-toggle.doc-view
                    class="btn-icon mx-25"
                    v-b-tooltip.hover.v-info.bottom
                    title="عرض المستند المرفوع"
                    :to="{ name: 'file-view', query: { ep:data.file } }"
                >
                    <feather-icon icon="EyeIcon"
                /></b-button>
                </div>
            </div>
            <div>
                <hr />
            </div>
            </div>
        </b-col>        
    </b-row>
  </template>
  
  <script>
  import { BCard , BImg , BCol , BRow , VBToggle , VBTooltip , BButton } from "bootstrap-vue";
  import InfoCard from "@/components/InfoCard.vue";
  import IdCard from "../IdCard/index.vue"
  export default {
    components: {
        BCard, BImg , BCol , InfoCard , BRow , BButton , IdCard
    },
    props: {
        data : Object ,
    },
    
    directives: {
        "b-toggle": VBToggle,
        "b-tooltip": VBTooltip,
    },
  };
  </script>